import { useMediaQuery } from 'react-responsive';
import { useState } from 'react';

import useViewerIntervalRequest from '../../../hooks/useViewerIntervalRequest';
import {
  EmbedItemType,
  MessageBoxItemType,
  PdfViewerRedirect,
} from '../index.types';
import RootLayout from '../../@common/RootLayout';
import MobilePageNavigation from '../../@common/PageNavigationDrawer/Mobile';
import DesktopPageNavigation from '../../@common/PageNavigationDrawer/Desktop';
import useUpdateOneToOneRenderThumbnails from '../../../hooks/useUpdateOneToOneRenderThumbnails';
import V2OneToOneViewer from '../../v2/V2OneToOneViewer';
import { useViewerRoute } from '../../../contexts/ViewerRoute';

import DesktopPage from './Page/Desktop';
import MobilePage from './Page/Mobile';

interface Props {
  data?: PdfViewerRedirect;
  messageBoxItems?: MessageBoxItemType[];
  embedItems?: EmbedItemType[];
  domain?: string;
  useWindowUnload: () => void;
  translateKoToEn: (item: string) => string;
}

const PdfRedirectPage = ({
  data,
  domain,
  messageBoxItems,
  embedItems,
  useWindowUnload,
  translateKoToEn,
}: Props) => {
  const { isBulk, isShareRoute } = useViewerRoute();
  const userAgent =
    typeof window !== 'undefined' ? window.navigator.userAgent : '';

  const [isMobileDrawerOpen, setIsMobileDrawerOpen] = useState(false);

  useWindowUnload();

  const isMobile =
    useMediaQuery({ maxWidth: 767 }) || /iPhone|Android/.test(userAgent);

  useViewerIntervalRequest({ isMobile });

  const isMobileLandscape =
    useMediaQuery({
      query: '(orientation: landscape)',
    }) && isMobile;

  const { updateNextThumbnails, updatePrevThumbnails } =
    useUpdateOneToOneRenderThumbnails({
      defaultThumbnails: data?.thumnail,
    });

  // const { version } = useViewerVersion();
  const version = 'v2';

  /* 버전 해석 전 단일 프레임: V1 플래시를 막기 위해 렌더를 보류한다 */
  if (isShareRoute && version === null) {
    return null;
  }

  if (isShareRoute && version === 'v2' && data) {
    return (
      <V2OneToOneViewer
        data={data}
        domain={domain}
        messageBoxItems={messageBoxItems}
        embedItems={embedItems}
        translateKoToEn={translateKoToEn}
      />
    );
  }

  return (
    <>
      {isMobile ? (
        <RootLayout mode="mobile">
          {data && (
            <>
              <MobilePage
                data={data}
                domain={domain}
                isBulk={isBulk}
                translateKoToEn={translateKoToEn}
                updateNextThumbnails={updateNextThumbnails}
                updatePrevThumbnails={updatePrevThumbnails}
                setIsMobileDrawerOpen={setIsMobileDrawerOpen}
                isMobileLandscape={isMobileLandscape}
              />
              <MobilePageNavigation
                translateKoToEn={translateKoToEn}
                pages={data?.thumnail}
                setIsMobileDrawerOpen={setIsMobileDrawerOpen}
                isMobileDrawerOpen={isMobileDrawerOpen}
                isMobileLandscape={isMobileLandscape}
              />
            </>
          )}
        </RootLayout>
      ) : (
        <RootLayout mode="desktop">
          {data && (
            <>
              <DesktopPageNavigation
                translateKoToEn={translateKoToEn}
                fileName={data?.name}
                pages={data?.thumnail}
              />
              <DesktopPage
                data={data}
                domain={domain}
                isBulk={isBulk}
                translateKoToEn={translateKoToEn}
                updateNextThumbnails={updateNextThumbnails}
                updatePrevThumbnails={updatePrevThumbnails}
                messageBoxItems={messageBoxItems}
              />
            </>
          )}
        </RootLayout>
      )}
    </>
  );
};

export default PdfRedirectPage;
